import { createContext, useContext, useState, ReactNode } from "react";

interface MobileNavContextType {
  showMobileNav: boolean;
  setShowMobileNav: (show: boolean) => void;
}

const MobileNavContext = createContext<MobileNavContextType | undefined>(undefined);

export function MobileNavProvider({ children }: { children: ReactNode }) {
  const [showMobileNav, setShowMobileNav] = useState(true);
  
  return (
    <MobileNavContext.Provider value={{ showMobileNav, setShowMobileNav }}>
      {children}
    </MobileNavContext.Provider>
  );
}

export function useMobileNav() {
  const context = useContext(MobileNavContext);
  if (!context) {
    // Return default values instead of throwing to prevent crashes
    return { 
      showMobileNav: true, 
      setShowMobileNav: () => {} 
    };
  }
  return context;
}
